type GenericObject = {
  // Needed to allow for indexing with a string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

function convertSnakeToCamel(str: string): string {
  return str.replace(/_([a-z])/g, (match, p1) => p1.toUpperCase());
}

export function convertKeysToCamelCase(obj: GenericObject): GenericObject {
  const result: GenericObject = {};
  for (const key in obj) {
    const camelKey = convertSnakeToCamel(key);
    if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      result[camelKey] = convertKeysToCamelCase(obj[key]); // Recurse for nested objects
    } else if (Array.isArray(obj[key])) {
      result[camelKey] = obj[key].map((item: unknown) => {
        if (item && typeof item === 'object') {
          return convertKeysToCamelCase(item); // Recurse for objects within arrays
        }
        return item;
      });
    } else {
      result[camelKey] = obj[key];
    }
  }
  return result;
}
